import { PublicClientApplication } from '@azure/msal-browser';
import { loginConfig } from '../../../environments/environment';

export const msalInstance = new PublicClientApplication({
 
        auth: {
          clientId: `${loginConfig.Client_ID}`,  // Replace with Azure App Client ID
          authority: `https://login.microsoftonline.com/${loginConfig.Tenant_ID}`, // Replace with Tenant ID
          redirectUri:  `${loginConfig.sso_redirectUrl}/sso-auth/callback`
        },
  cache: {
    cacheLocation: "sessionStorage", // Ensures the nonce is not lost
    storeAuthStateInCookie: true, // Helps with iframe-based login issues
  }
});